import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <div className="greet-main" id="greeting">
      <div className="minimalist-profile-container">
        <div className="profile-card">
          {/* Profile Photo */}
          <div className="profile-photo-section">
            <img
              src={require("../../assests/images/rhea.jpeg")}
              alt="Rhea Adhikari"
              className="profile-photo"
            />
          </div>

          {/* Profile Content */}
          <div className="profile-content-section">
            <h1
              className="profile-name"
              style={{ color: theme.imageHighlight }}
            >
              {greeting.title}
            </h1>
            <p
              className="profile-description"
              style={{ color: theme.secondaryText }}
            >
              {greeting.subTitle}
            </p>

            {/* Social Media Icons */}
            <div className="profile-social">
              <SocialMedia theme={theme} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
